export default __webpack_public_path__ + "static/media/3.afc72c4d.png";